import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatPricingDate } from '../../../utils/formatHelper';

export function PricingTableSalePrices({ prices }) {
  const saleStart = useMemo(() => formatPricingDate(prices.sale_start), [prices.sale_start]);
  const saleEnd = useMemo(() => formatPricingDate(prices.sale_end), [prices.sale_end]);

  return (
    <>
      <td key="sale_start">{saleStart}</td>
      <td key="sale_end">{saleEnd}</td>
    </>
  );
}

PricingTableSalePrices.propTypes = {
  prices: PropTypes.shape({
    sale_start: PropTypes.string,
    sale_end: PropTypes.string,
  }).isRequired,
};
